import { createFileRoute } from '@tanstack/react-router'
import { homeSearchSchema } from '../../features/reports/operational-search'
import { HomePage } from '../../features/shell/home-page'

export const Route = createFileRoute('/_app/')({
  staticData: { crumb: 'home' },
  validateSearch: homeSearchSchema,
  component: HomePage,
})
